<template>
    <div>
        <div class="org-tree-layout">
            <swb-popover-org-tree :showMgmt="true" :showIncludeSubComs="true" :tmpBizDepart="false" :bizDepart="true" @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :onConfigReady="onConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="simple-row">
            <div class="right">
                <a class="swb-btn swb-btn-small swb-btn-primary" @click="doExport">导出</a>
            </div>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName"
                          :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight"
                          :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>
<script>
    import {Utils, $} from '../../app.base'
    import {Vue, MsgBox, DomSizeWatcher, Routes, showPageRangeSelDlg} from '../../app.vues'
    import {getDefaultPageSizes, getDefaultDownloadPageSize} from '../../app.conf';
    import {checkUserActionPerm} from '../index'
    import {showRouteLayer} from '../ctrl/RouteLayer'
    import {showGrpDownloadDlg} from '../ctrl/dialog'

    import userApi from '../../api/user'
    import goodsDelivApi from '../../api/goodsDeliv'

    import SwbGoodsRecvVoucherSure from './GoodsRecvVoucherSure';

    Routes.add(SwbGoodsRecvVoucherSure);

    import SwbGoodsShipVoucherInfo from './GoodsShipVoucherInfo';

    Vue.regist(SwbGoodsShipVoucherInfo);

    import SwbGoodsOrderApply from './GoodsOrderApply';

    Vue.regist(SwbGoodsOrderApply);

    import SwbLogisTraceInfo from './LogisTraceInfo';

    Vue.regist(SwbLogisTraceInfo);
    //
    import SwbGoodsOrderList from './GoodsOrderList';

    Routes.add(SwbGoodsOrderList);

    import SwbContractGoodsOrderList from './ContractGoodsOrderList';

    Routes.add(SwbContractGoodsOrderList);
    import SwbQuerySortArea from '../query/QuerySortArea';

    Vue.regist(SwbQuerySortArea);
    import SwbOrgTree from '../orgStruct/OrgTree';

    Vue.regist(SwbOrgTree);

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    export default {
        name: 'swb-goods-ship-voucher-list',
        path: '/goods/ship/voucher/list',
        avlActions: 'to_order_list|view_detail|view_logis|confirm_recv',
        avlActionNames: '查看、物流查询、确认收货',
        avlScopes: 'retailer',
        desc: '发货单列表',
        props: ['goodsOrderId'],
        data: function () {
            return {
                confKey: 'swb-goods-ship-voucher-list',
                theTableHeight: 300,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                exportFilter: {},
                //
                goodsShipVoucherList: [],
                buyerId: null,
                sellerName: null,
                no: null,
                buyerShopName: null,
                logisExpNo: null,
                searchShow: false,
                //
                comLevel: null,
                selectComId: null,
                includeSubComs: false,
                initIncludeSubComs: false,
                treeCollapse: true,
                enableSearch: true,
                isClickEvent: true,
                //
                currentComId: null,
                currentComLevel: null,
                mgmtSmlAreaId: null,
                scopeEntity: null
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.no = this.$route.query.no || null;
            // --------------------查询--------------------------------
            this.userCurrentInfo();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('.org-tree-layout, .simple-row, [name="query-sort-block"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if (domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onConfigReady: function () {
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let no = this.no;
                if (!Utils.isNoB(no)) {
                    let data = {value: no};
                    let fieldInfo = {};
                    fieldInfo["no"] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'no': function (row, colName, colValue, rowIndex, btnName) {
                        if (self.checkActionPerm('view_detail')) {
                            return '<a class="table-cell-link" ref="#">' + row.no + '</a>';
                        } else {
                            return row.no;
                        }
                        return '<span>' + row.user.phoneNo + '</span> '
                    },
                    'orderNo': function (row, colName, colValue, rowIndex, btnName) {
                        if (Utils.isTrue(row.orderFlag)) {
                            if (self.checkActionPerm('to_order_list')) {
                                return '<span :tilte="row.orderNo"><a class="table-cell-link" ref="#">' + row.orderNo + '</a></span>'
                            } else {
                                return '<span :tilte="row.orderNo">' + row.orderNo + '</span>';
                            }
                        }
                    },
                    'confirmedX': function (row, colName, colValue, rowIndex, btnName) {
                        let domHtml = '';
                        if (row.invalid == 0) {
                            if (row.receiveState == 1) {
                                domHtml = domHtml + '<el-tag type="success" style="background-color: transparent; border: none" close-transition>' + "已部分收货" + '</el-tag>'
                            }
                            if (row.receiveState == 2) {
                                domHtml = domHtml + '<el-tag type="success" style="background-color: transparent; border: none" close-transition>' + "已全部收货" + '</el-tag>'
                            }
                            if (row.receiveState == -1) {
                                domHtml = domHtml + '<el-tag type="danger" style="background-color: transparent; border: none" close-transition>' + "已拒收" + '</el-tag>'
                            }
                            if (row.receiveState == 0) {
                                if (row.confirmed == true) {
                                    domHtml = domHtml + '<el-tag type="success" style="background-color: transparent; border: none" close-transition>' + "已发货" + '</el-tag>'
                                }
                                if (row.confirmed == false) {
                                    domHtml = domHtml + '<el-tag type="danger" style="background-color: transparent; border: none" close-transition>' + "未发货" + '</el-tag>'
                                }
                            }
                        } else if (row.invalid == 1) {
                            domHtml = domHtml + '<el-tag type="danger" style="background-color: transparent; border: none" close-transition>' + "已作废" + '</el-tag>'
                        }
                        return domHtml;
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let domHtml = '';
                        //  上级可帮下级收货  && (self.currentComId == row.buyerShopId || self.currentComLevel == 1)
                        if (self.checkActionPerm('confirm_recv') && row.receiveState == 0 && row.invalid == false && row.confirmed == true) {
                            domHtml = domHtml + '<a name="confirm_recv" class="swb-btn swb-btn-link">确认收货</a>';
                        }
                        if (self.checkActionPerm('view_detail')) {
                            domHtml = domHtml + '<a name="view_detail" class="swb-btn swb-btn-link">查看</a>';
                        }
                        if (self.checkActionPerm('view_logis') && row.logisExpNo != null && row.logisComCode != null) {
                            domHtml = domHtml + '<a name="view_logis" class="swb-btn swb-btn-link">物流查询</a>';
                        }
                        return domHtml;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    'no': function (row, colName, colValue, rowIndex, btnName) {
                        self.showShipInfoDlg(row.id)
                    },
                    'orderNo': function (row, colName, colValue, rowIndex, btnName) {
                        self.toGoodsOrderInfo(row.orderNo, row.goodsOrder.contractId)
                    },
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if (!Utils.repeatChecker.isValidFor(btnName, 1000)) {
                            return;
                        }
                        if (btnName == 'confirm_recv') {
                            self.confirmedRecv(row.id, row.orderId);
                        } else if (btnName == 'view_detail') {
                            self.showShipInfoDlg(row.id);
                        } else if (btnName == 'view_logis') {
                            self.logisFound(row.logisExpNo, row.logisComCode);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if (!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            checkComCatChange: function (eventData) {
                if (Utils.isTrue(eventData.mgmtFlag)) {
                    let scopeEntity = this.scopeEntity;
                    this.mgmtSmlAreaId = eventData.id;
                    this.comLevel = scopeEntity.comLevel;
                    this.selectComId = scopeEntity.comId;
                    this.includeSubComs = true;
                } else {
                    this.mgmtSmlAreaId = null;
                    this.comLevel = eventData.level;
                    this.selectComId = eventData.id;
                    this.includeSubComs = eventData.includeSubComs;
                }
                this.getGoodsShipVoucherList();
            },
            showTreeCollapse: function (treeCollapse) {
                this.treeCollapse = treeCollapse;
            },
            //
            queryHandler(queryModel) {
                //1、接收查询条件
                this.queryModel = queryModel;
                this.pageNumber = 1;
                //缓存查询条件
                this.getGoodsShipVoucherList();

            },
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            showSearch: function (flag) {
                this.searchShow = flag;
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getGoodsShipVoucherList();
            },
            // 发货单列表
            getGoodsShipVoucherList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                filterItems.buyerShopId = this.selectComId;
                filterItems.comLevel = this.comLevel || null;
                filterItems.includeSubComs = this.includeSubComs;
                filterItems.mgmtSmlAreaId = this.mgmtSmlAreaId;
                if (!Utils.isNoB(self.no)) {
                    filterItems.no = self.no;
                }
                //
                let state = filterItems.state;
                if (!Utils.isNoB(state)) {
                    if (state == 'partRecv') {
                        filterItems.invalid = 0;
                        filterItems.receiveState = 1;
                    } else if (state == 'allRecv') {
                        filterItems.invalid = 0;
                        filterItems.receiveState = 2;
                    }/* else if(state == 'refusedRecv') {
                     filterItems.invalid = 0;
                     filterItems.receiveState = -1;
                     }*/ else if (state == 'shiped') {
                        filterItems.invalid = 0;
                        filterItems.confirmed = true;
                        filterItems.receiveState = 0;
                    } else if (state == 'toShip') {
                        filterItems.invalid = 0;
                        filterItems.confirmed = false;
                        filterItems.receiveState = 0;
                    } else if (state == 'invalid') {
                        filterItems.invalid = 1;
                    }
                }
                //
                if (!Utils.isNoB(self.goodsOrderId)) {
                    filterItems.orderId = self.goodsOrderId;
                }
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                self.exportFilter = Utils.merge({}, filterItems);
                //
                let msgBoxDlg = MsgBox.loading();
                goodsDelivApi.getGoodsShipVoucherList(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type === "info") {
                        let data = result.data;
                        self.goodsShipVoucherList = data.rows;
                        //
                        let pagination = data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pagesize = pagination.pageSize;
                        self.renderTable(data.rows, pagination);
                    } else {
                        self.$message.error(result.message);
                    }
                });
            },
            userCurrentInfo: function () {   // 当前登录信息
                let self = this;
                let data = {};
                userApi.getUserInfoByContext(data, function (result) {
                    if (result.type === "info") {
                        let userInfo = result.data;
                        let scopeEntity = userInfo.scopeEntity;
                        self.currentComId = scopeEntity.comId;
                        self.selectComId = scopeEntity.bizUnitId;
                        self.scopeEntity = scopeEntity.scopeEntity;
                        // self.getGoodsShipVoucherList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 发货单详情
            showShipInfoDlg: function (id) {
                Vue.$showDialog({
                    title: '发货单信息',
                    width: -200,
                    height: -100,
                    template: '<swb-goods-ship-voucher-info :id="id" ref="swb_goods_ship_voucher_info"></swb-goods-ship-voucher-info>',
                    data: {
                        id: id
                    },
                    methods: {},
                    okClicked: function () {
                    },
                })
            },

            //拒收
            rejectionShipVoucher: function (id) {
                let self = this;
                Vue.$showDialog({
                    title: "拒收操作",
                    width: 600,
                    height: 260,
                    template: '<div><swb-goods-order-apply ref="swb_rejection_ship"></swb-goods-order-apply>' +
                    '</div>',
                    data: {},
                    methods: {},
                    okClicked: function () {
                        let result = this.$refs.swb_rejection_ship.getDlgResult() || {};
                        if (result.type == 'info') {
                            let postData = {};
                            postData.id = id;
                            postData.exceptionDesc = result.exceptionDesc;
                            //
                            let msgBoxDlg = MsgBox.loading();
                            goodsDelivApi.refuseGoodsShipVoucher(postData, function (result) {
                                msgBoxDlg.close();
                                if (result.type == 'info') {
                                    self.getGoodsShipVoucherList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            });
                        }
                    }
                });
            },
            // 确认收货
            confirmedRecv: function (id, orderId) {
                let pushData = {};
                pushData.path = SwbGoodsRecvVoucherSure.path;
                pushData.query = {id: id, orderId: orderId};
                this.$router.push(pushData);
            },
            // 跳转商品订单
            toGoodsOrderInfo: function (orderNo, contractId) {
                let self = this;
                let query = {
                    no: orderNo
                };
                if (contractId != null) {
                    query.contractId = contractId;
                }
                userApi.getUserInfoByContext({}, function (result) {
                    if (result.type === "info") {
                        let comLevel = result.data.scopeEntity.comLevel;
                        if (comLevel == 1) {
                            if (contractId != null) {
                                showRouteLayer({
                                    title: '合同订单',
                                    query: query,
                                    template: SwbContractGoodsOrderList
                                });
                            } else {
                                showRouteLayer({
                                    title: '商品订单',
                                    query: query,
                                    template: SwbGoodsOrderList
                                });
                            }
                        } else {
                            MsgBox.warning("非总公司，不可查看合同订单");
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 查看物流
            logisFound: function (logisExpNo, logisComCode) {
                if (logisExpNo != null && logisComCode != null) {
                    //
                    Vue.$showDialog({
                        title: '物流信息',
                        width: 900,
                        height: 700,
                        showCloseBtn: true,
                        cancelText: '关闭',
                        okVisible: false,
                        template: '<div>' +
                        '<swb-logis-trace-info :logisExpNo="logisExpNo" :logisComCode="logisComCode" ref="swb_logis_trace_info"></swb-logis-trace-info>' +
                        '</div>',
                        data: {
                            logisExpNo: logisExpNo,
                            logisComCode: logisComCode
                        },
                        methods: {},
                        okClicked: function () {
                        }
                    })
                } else {
                    MsgBox.warning('物流参数信息异常');
                }
            },
            // 导出
            doExport: function () {
                let self = this;
                let pageSize = getDefaultDownloadPageSize();
                let pages = Math.ceil(self.totalCount / pageSize);
                if (pages > 10) {
                    showPageRangeSelDlg("选择导出文件序号", pages, 10, this.lastPageNumber, function (ok, range) {
                        if (ok) {
                            if (range.to == pages) {
                                self.lastPageNumber = 0;
                            } else {
                                self.lastPageNumber = range.to;
                            }
                            //
                            self.exportPrintData(pageSize, range.from, range.to);
                        }
                    }, {pageSize: pageSize})
                } else {
                    self.exportPrintData(pageSize);
                }
            },
            exportPrintData(pageSize, fromPages, toPages){
                let totalCount = this.totalCount;
                let pages = Math.ceil(totalCount / pageSize);
                //
                fromPages = fromPages == null ? 1 : fromPages;
                toPages = toPages == null ? pages : toPages;
                let tableData = this.getTableData(pages, pageSize);
                //
                let url = getAppUrl("/file/export/as/excel");
                let downloadUrls = [];
                for (let i = fromPages; i <= toPages; i++) {
                    let tmpFile = {};
                    tmpFile.url = url;
                    tmpFile.post = true;
                    tmpFile.fileName = "供方发货协同" + (pages == 1 ? '' : ("_" + (i)));
                    tmpFile.seqNo = i;
                    //
                    let data = Utils.merge({}, tableData);
                    data.pageNumber = i;
                    data.fileName = tmpFile.fileName;
                    tmpFile.data = data;
                    downloadUrls.push(tmpFile);
                }
                let title = '供方发货协同-下载| 每个文件' + pageSize + '条数据';
                showGrpDownloadDlg(title, downloadUrls);
            },
            getTableData(pages, pageSize){
                let resultTable = this.$refs.result_table;
                let tableData = resultTable.getTableData(true);
                delete tableData.rows;//减少数据传输量
                //
                let rowsSrc = {};
                rowsSrc.data = this.getPostData();
                rowsSrc.url = "/goodsDeliv/ship/voucher/list";
                tableData.rowsSrc = rowsSrc;
                //
                tableData.pageSize = pageSize;
                tableData.pageCount = this.totalCount;
                tableData.pages = pages;
                return tableData;
            },
            getPostData(){
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, this.exportFilter);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                let multipleSelection = this.getTableSelection();
                if (multipleSelection.length > 0) {
                    let ids = [];
                    multipleSelection.forEach(function (el) {
                        ids.push(el.id);
                    });
                    filterItems.ids = ids;
                }
                filterItems.exportFlag = true;
                //
                let postData = {};
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                return postData;
            },
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/order/GoodsShipVoucherList.vue